export  default {
  setChangeTrackingByContainer(state, payload){
    state.changesContainer = payload;
  }
};